export default "__VITE_ASSET__ercaITOQ__"